import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { first, map, tap } from 'rxjs/operators';

import { UserService } from '@atmi/core/services/user.service';

@Injectable()
export class AuthGuardService  {

  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    const authenticated = route.data ? route.data.authenticated : true;

    return this.userService.selectAuthenticatedState().pipe(
      first(),
      map((auth) => auth === authenticated),
      tap((auth) => {
        if (authenticated && !auth) {
          this.router.navigate(['/login']);
        }

        if (!authenticated && !auth) {
          this.router.navigate(['/home']);
        }
      }),
    );
  }

}
